import { Response, Team } from 'lib-shared-legacy-types';

import { ajaxSend } from 'api/api';

import { TeamPayload, TeamsGetItemsResponse, TeamsQueryParams } from './types';

const basePath = '/v1/teams';

export const getTeams = (
  params: TeamsQueryParams = {},
): Promise<TeamsGetItemsResponse> =>
  ajaxSend({
    path: basePath,
    params: params as any,
  });

export const getTeam = (teamId: string): Promise<Response<Team>> =>
  ajaxSend({ path: `${basePath}/${teamId}` });

export const createTeam = (data: TeamPayload) =>
  ajaxSend({
    path: basePath,
    method: 'POST',
    data,
  });

export const removeTeam = (teamId: string) =>
  ajaxSend({
    method: 'DELETE',
    path: `${basePath}/${teamId}`,
  });
